import { close, onEscape, open } from "./dom.js";

// The modal is an onboarding nudge, not a gate, so it waits for the page to
// settle before appearing.
const SHOW_DELAY_MS = 1000;

export function initWelcomeModal() {
  const modal = document.querySelector(".welcome-modal");
  const closeButton = document.querySelector(".welcome-modal__close-icon");
  const overlay = document.querySelector(".main-page-overlay");

  if (!modal || !closeButton || !overlay) {
    return;
  }

  const closeModal = () => close(modal, overlay);

  closeButton.addEventListener("click", closeModal);
  onEscape(modal, closeModal);

  setTimeout(() => open(modal, overlay), SHOW_DELAY_MS);
}
